import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// icons
import positionMakerIcon from './shared/static/icons/position-marker.svg';
import settingIcon from './shared/static/icons/settings-gear.svg';
import pinsIcon from './shared/static/icons/pins.svg';
import notesIcon from './shared/static/icons/notes.svg';

class Home extends Component {
  render() {
    return (
      <div>
        <div className="content-area">
          <div className="container">
            <h3 className="heading">Product showcase</h3>
            <div className="tile-grid">
              <Link to="/poinetwork">
                <div className="tile">
                  <img src={positionMakerIcon} alt="POI Network"/>
                  <h4 className="title-level-2">POI Network</h4>
                </div>
              </Link>
              <Link to="/confirmGeofence">
                <div className="tile">
                  <img src={settingIcon} alt="Geofence Creation"/>
                  <h4 className="title-level-2">Geofence Creation</h4>
                </div>
              </Link>
              <Link to="/events">
                <div className="tile">
                  <img src={pinsIcon} alt="Location Data" />
                  <h4 className="title-level-2">Location Data</h4>
                </div>
              </Link>
              <Link to="">
                <div className="tile">
                  <img src={notesIcon} alt="Location Taxonomy" />
                  <h4 className="title-level-2">Location Taxonomy</h4>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js